export default __webpack_public_path__ + "static/media/success.50f64cc5.gif";